export const HEADER_SUBDOMAIN = 'X-Blossom-Subdomain'
export const HEADER_DEVICE_TOKEN = 'X-Blossom-DeviceToken'
export const HEADER_VERSION_HASH = 'X-Blossom-VersionHash'

export const CONTEXT_ORGANIZATION = 'ORGANIZATION'
export const CONTEXT_NURSERY = 'NURSERY'
export const CONTEXT_ADMIN = 'ADMIN'
